import script from "./ConnectionsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectionsSection.vue?vue&type=script&setup=true&lang=js"

import "./ConnectionsSection.vue?vue&type=style&index=0&id=5d401843&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d401843"]])

export default __exports__